export default __webpack_public_path__ + "static/media/analogueAtticCover4.84fa0ea9.jpg";